import { render, staticRenderFns } from "./fundpay-abnormal.vue?vue&type=template&id=386417c5&"
import script from "./fundpay-abnormal.vue?vue&type=script&lang=js&"
export * from "./fundpay-abnormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports